@if (initialized) {
  <div class="container">
    @if (!equipmentTypes.length) {
      <div class="mat-body-strong">
        No data found
      </div>
    }
    <div class="columns">
      <div>
        <div class="mat-subtitle-1">Org equipment</div>
        @for (equipmentType of equipmentTypes; track equipmentType) {
          <div>
            <mat-checkbox [checked]="equipmentType.checked" (change)="onCheckToggle(equipmentType, $event.checked)">
              <div class="mat-body-strong">
                {{equipmentType.name}}
              </div>
            </mat-checkbox>
          </div>
        }
      </div>
      <div>
        <div class="mat-subtitle-1">Project equipment</div>
        @for (equipmentType of projectEquipmentTypes; track equipmentType) {
          <div class="mat-body-strong">
            {{equipmentType.name}}
          </div>
        }
      </div>
    </div>
  </div>
}